class Accordion {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector('.content');
    this.accordionItems = document.querySelectorAll('.accord-item');

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  /**
   * Handles click event on summary element
   *
   * @param {Event} e - click event
   * @return {void}
   */
  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = 'hidden';

    if (this.isClosing || !this.el.open) {
      this.open();
      this.resetAccordions(this);
    } else if (this.isExpanding || this.el.open) {
      this.close();
    }
  }

  /**
   * Resets all accordion elements to be closed except for the element that was passed in
   * @param {HTMLElement} element - The element to not reset
   * @return {void}
   */
  resetAccordions(element) {
    this.accordionItems.forEach((item) => {
      if (item !== element.el) {
        item.removeAttribute('open');
        item.open = false;
      }
    });
  }

  /**
   * Closes the accordion element
   *
   * @return {void}
   */
  close() {
    this.isClosing = true;

    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate({ height: [startHeight, endHeight] }, { duration: 400, easing: 'ease-out' });

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => (this.isClosing = false);
  }

  /**
   * Opens the accordion element
   *
   * @return {void}
   */
  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  /**
   * Expands the accordion element
   *
   * @return {void}
   */
  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate({ height: [startHeight, endHeight] }, { duration: 400, easing: 'ease-out' });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  /**
   * Handles the end of an animation
   *
   * @param {boolean} open - Whether the accordion is open or closed
   * @return {void}
   */
  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = '';
  }
}

document.querySelectorAll('details').forEach((el) => {
  new Accordion(el);
});
